module.exports = __webpack_public_path__ + "img/linkedin.light.98dc6a65.svg";